import React from 'react';
import RecommendTagSaveNavbar from '../RecommendTagSaveNavbar';
import RecommendTagSaveInfo from '../RecommendTagSaveInfo';
import RecommendTagSaveItemList from '../RecommendTagSaveItemList';
import './RecommendTagSaveWrap.scss';

const RecommendTagSaveWrap = (props) => {
  const {
    form,
    recommendTagSave,
    setData,
    getRecommendTagItemList,
    selectRecommendTagItemList,
    onSubmit,
    onDragEndSelectRecommendStoreItemList,
    getRecommendTagItemListExcelDownload,
    getSelectedRecommendTagItemListExcelDownload,
    setRecommendTagItemListExcelUpload,
    typeDisabled,
  } = props;
  const { recommendTagInfo, recommendTagItemList } = recommendTagSave;

  return (
    <div className="recommend-tag-save-wrap">
      {/* 하단 네브바 */}
      <RecommendTagSaveNavbar onSubmit={onSubmit} />

      {/* 추천 상품 후기 정보 */}
      <RecommendTagSaveInfo
        form={form}
        setData={setData}
        recommendTagInfo={recommendTagInfo}
        typeDisabled={typeDisabled}
      />

      {/* 추천 태그 아이템 리스트*/}
      <RecommendTagSaveItemList
        recommendTagItemList={recommendTagItemList}
        getRecommendTagItemList={getRecommendTagItemList}
        selectRecommendTagItemList={selectRecommendTagItemList}
        onDragEndSelectRecommendStoreItemList={onDragEndSelectRecommendStoreItemList}
        getRecommendTagItemListExcelDownload={getRecommendTagItemListExcelDownload}
        getSelectedRecommendTagItemListExcelDownload={getSelectedRecommendTagItemListExcelDownload}
        setRecommendTagItemListExcelUpload={setRecommendTagItemListExcelUpload}
      />
    </div>
  );
};

export default RecommendTagSaveWrap;
